/**
 * ScopeBadge — tells the operator WHERE a setting persists.
 *
 * The old page mixed per-location, org-wide and per-browser settings side by
 * side with no signal (e.g. Picking Mode was localStorage while the adjacent
 * Verification Mode was per-location DB). Every section header in the Console
 * carries one of these so scope is never a surprise.
 */
import { cn } from '@/lib/utils';
import type { SettingScope } from '../../areas';

const SCOPE_STYLES: Record<SettingScope, { label: string; className: string }> = {
  location: {
    label: 'Per location',
    className: 'bg-sky-50 text-sky-700 border-sky-200',
  },
  org: {
    label: 'Organization',
    className: 'bg-primary/10 text-primary border-primary/20',
  },
  browser: {
    label: 'This browser',
    className: 'bg-muted text-muted-foreground border-border',
  },
};

export function ScopeBadge({ scope, className }: { scope: SettingScope; className?: string }) {
  const style = SCOPE_STYLES[scope];
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide whitespace-nowrap',
        style.className,
        className,
      )}
    >
      {style.label}
    </span>
  );
}
